import { render, staticRenderFns } from "./TailwindTestView.vue?vue&type=template&id=01cca64e&scoped=true"
import script from "./TailwindTestView.vue?vue&type=script&lang=js"
export * from "./TailwindTestView.vue?vue&type=script&lang=js"
import style0 from "./TailwindTestView.vue?vue&type=style&index=0&id=01cca64e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cca64e",
  null
  
)

export default component.exports